import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent, DialogHeaderComponent } from '@cumlaude/shared-components-dialogs';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { FormsModule } from '@angular/forms';
import { AutofocusDirective } from '@cumlaude/shared-components-inputs';

export type OpmerkingDialogData = {
	/** Gevuld bij het bewerken van een bestaande notitie, leeg bij een nieuwe. */
	tekst?: string;
	/** Leeg bij een notitie over de hele conversatie. */
	turnIndex?: number | null;
};

@Component({
	selector: 'app-ai-chat-opmerking-dialog',
	templateUrl: './ai-chat-opmerking-dialog.component.html',
	styleUrls: ['./ai-chat-opmerking-dialog.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, ButtonComponent, FormsModule, AutofocusDirective],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AIChatOpmerkingDialogComponent {
	dialogRef = inject<DialogRef<string>>(DialogRef);

	data = inject<OpmerkingDialogData | null>(DIALOG_DATA, { optional: true });

	tekst = model<string>(this.data?.tekst ?? '');

	get titel(): string {
		if (this.data?.tekst) return 'Opmerking bewerken';
		return this.data?.turnIndex == null ? 'Opmerking bij deze conversatie' : `Opmerking bij bericht ${this.data.turnIndex + 1}`;
	}

	/**
	 * Enter sluit de dialoog niet: in een werknotitie is een nieuwe regel waarschijnlijker dan een
	 * afronding, en de tekst wordt als markdown gerenderd. Met Cmd/Ctrl + Enter wordt wel opgeslagen.
	 */
	keyDown(event: KeyboardEvent) {
		if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
			this.opslaan();
			event.preventDefault();
			return;
		}

		if (event.key === 'Escape') {
			this.dialogRef.close();
			event.preventDefault();
		}
	}

	opslaan() {
		const tekst = this.tekst().trim();
		if (tekst) this.dialogRef.close(tekst);
	}
}
